export class Localidad {
  id: string;
  nombre: string;
  codigoPostal: string;
  provinciaId: string;
}
